import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-google-sheets',
  templateUrl: './help-add-export-google-sheets.component.html',
  styleUrls: ['./help-add-export-google-sheets.component.scss']
})
export class HelpAddExportGoogleSheetsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
